import React from 'react';
import { toPercentage } from '@/utils/text';

const SIZE_PX = 112;
const STROKE_PX = 12;
const RADIUS = (SIZE_PX - STROKE_PX) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface Props {
  percent: number;
}

export const JournalAttendanceGauge: React.FC<Props> = ({ percent }) => {
  const progress = (Math.min(percent, 100) / 100) * CIRCUMFERENCE;

  return (
    <div className="relative size-[50px] shrink-0 md:size-28">
      <svg
        viewBox={`0 0 ${SIZE_PX} ${SIZE_PX}`}
        className="size-full -rotate-90"
      >
        <circle
          cx={SIZE_PX / 2}
          cy={SIZE_PX / 2}
          r={RADIUS}
          fill="none"
          strokeWidth={STROKE_PX}
          className="stroke-on-primary-surface"
        />
        <circle
          cx={SIZE_PX / 2}
          cy={SIZE_PX / 2}
          r={RADIUS}
          fill="none"
          strokeWidth={STROKE_PX}
          strokeLinecap="round"
          strokeDasharray={`${progress} ${CIRCUMFERENCE}`}
          className="stroke-primary"
        />
      </svg>
      <span className="text-body-13 md:text-headline-20 absolute inset-0 flex items-center justify-center font-semibold text-primary">
        {toPercentage(percent)}
      </span>
    </div>
  );
};
